import { useSelector } from "react-redux";

export const useParamNavigation = () => {
    const { currentValuation } = useSelector((store) => store.valuationsDetails)

    const pathWithPropId = (path) => {
        return `/valuations/${currentValuation}/${path}`
    }

    return { pathWithPropId };
}

export default useParamNavigation;
